module.exports = __webpack_public_path__ + "./assets/img_sanchong_grey@2x__4ac71f81db053ed11a471d5f5fc73389.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/img_sanchong_grey@2x.jpg
// module id = 623
// module chunks = 12